/**
 * @prettier
 */
import React from 'react';
import PropTypes from 'prop-types';

export const Products = (props) => {
  // this is a placeholder Component so that the ContentfuContent component in
  // gatsby-theme-ripperoni-cms has something to render when it encounters an atomProducts

  Products.propTypes = {};

  return null;
};

Products.displayName = 'Products';
